import React, { useEffect, useState } from 'react';
import { Flame } from 'lucide-react';
const TOTAL_SECONDS = 24 * 60 * 60;
export function CountdownBar() {
  const [secondsLeft, setSecondsLeft] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const hours = Math.floor(secondsLeft / 3600);
  const minutes = Math.floor(secondsLeft % 3600 / 60);
  const seconds = secondsLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-pastel-lavender-dark via-pastel-pink to-pastel-lavender-dark text-white shadow-sm" data-id="element-53">
      <div className="container mx-auto px-3 py-1.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-center text-[11px] sm:text-xs font-bold" data-id="element-54">
        <Flame size={13} className="text-yellow-200 animate-pulse" data-id="element-55" />
        <span className="uppercase tracking-wider" data-id="element-56">Oferta termina en</span>
        <div className="flex items-center gap-0.5 font-mono tabular-nums" data-id="element-57">
          <span className="bg-white/20 backdrop-blur-sm rounded px-1.5 py-0.5" data-id="element-58">
            {pad(hours)}h
          </span>
          <span className="text-yellow-200" data-id="element-59">:</span>
          <span className="bg-white/20 backdrop-blur-sm rounded px-1.5 py-0.5" data-id="element-60">
            {pad(minutes)}m
          </span>
          <span className="text-yellow-200" data-id="element-61">:</span>
          <span className="bg-white/20 backdrop-blur-sm rounded px-1.5 py-0.5" data-id="element-62">
            {pad(seconds)}s
          </span>
        </div>
        <a href="#oferta" className="hidden sm:inline-block ml-1 bg-white text-pastel-lavender-dark rounded-full px-2.5 py-0.5 hover:bg-yellow-100 transition-colors" data-id="element-63">
          Aprovechar →
        </a>
      </div>
    </div>;
}